import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
// external dependencies
import { NgxFilesizeModule } from 'ngx-filesize';
import { NgxFileDropModule } from 'ngx-file-drop';

// dependencies
import { HelperBoxModule } from '@core/components/helpers/box/box.module';
import { PipesModule } from '@core/pipes/pipes.module'

import { CoreStorageFilesUploadComponent } from './storage-files-upload/storage-files-upload.component';
import { CoreStorageFileUploadedListItemComponent } from './storage-file-uploaded-list-item/storage-file-uploaded-list-item.component';



@NgModule({
  imports: [
    CommonModule,
    NgxFilesizeModule,
    NgxFileDropModule,
    HelperBoxModule,
    PipesModule
  ],
  declarations: [
    CoreStorageFilesUploadComponent,
    CoreStorageFileUploadedListItemComponent
  ],
  exports: [
    CoreStorageFilesUploadComponent,
    CoreStorageFileUploadedListItemComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class CoreStorageModule { }
